import * as React from "react";
import { SignInHeaderNav } from "./SignInHeaderNav";
import { signInHeaderStyles } from "./SignInHeaderStyles";

const useStyles = signInHeaderStyles;

export const SignInHeader: React.FC = () => {
  const styles = useStyles();
  const [isSignInComponentOpen, setIsSignInComponentOpen] =
    React.useState(true);

  const handleSignInComponentClose = () => {
    setIsSignInComponentOpen(false);
  };

  return (
    <div className={styles.main}>
      {isSignInComponentOpen && (
        <div className={styles.bar}>
          <SignInHeaderNav onClose={handleSignInComponentClose} />
        </div>
      )}
    </div>
  );
};
